export const REPORTING = {
  ID: '187222785879',
  URL: 'https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLK8orAGfMflHeC1ibgzakrSI2RqJYQ5udaRjWjHWgAM7jskF5%2FEgAOL4OTxMod%2BueHY91%2F9cO6pMvbDaqJTAJo0I5B3CqiokTzo8OzDoDHVLYsBrE%2BP8d0eOgGdg3PAHST9UA%3D%3D&webInteractiveContentId=187222785879&portalId=45160067',
  IMG: 'https://no-cache.hubspot.com/cta/default/45160067/interactive-187222785879.png',
};

export const DASHBOARD = {
  ID: '184500197013',
  URL: 'https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLKR9vhkphVkYC2lAVgbW%2B%2F2WRZ%2BzgYZwomU116%2FDlsRES%2B86zwEIqNC%2FpVf3RrouE7ZQqD9Y1ShPzKNli1EU5XzXgbpROHIDkXx4DsqBl95CxJbNsFjvqQZ2cvHuygzTP3Uk91GZoyoRvzO59%2FRkd9gi9UIyCaPcbI%3D&webInteractiveContentId=184500197013&portalId=45160067',
  IMG: 'https://no-cache.hubspot.com/cta/default/45160067/interactive-184500197013.png',
};

export const TUTORIAL_COURSES = {
  ID: '187923358284',
  URL: 'https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLKmzEp0z6DRMfceOBUWHOxdYnxoHxDvEIwxpr08MrURZ6twDZKFTWE9b%2BPUuAXllGNbcfxYMfpq%2Bu6r0ZvmLnWcdRAA7BGPYSiQ6GoewNAWUJzEpyE%2BkB6JcawEL5WM85ZgzRgpgCnk1qsDQTWocgFW%2FC3s&webInteractiveContentId=187923358284&portalId=45160067',
  IMG: 'https://no-cache.hubspot.com/cta/default/45160067/interactive-187923358284.png',
};
